import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';

import { Link, Redirect } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class FatigueReasonsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: {},
      name: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/fadigas/motivos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
        if (responseJson.status === 'success') {
          self.setState({
            data: responseJson.data,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/fadiga/motivo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var data_temp = self.state.data;
          data_temp.push(responseJson.data);
          self.setState({data: data_temp});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fadiga/motivo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteRow(id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({fatigue_options_data: data});
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <div>
        <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.formulario.Nome}:</label>
                <input type="text" name="name" className="form-control" placeholder={this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.formulario.placeholder.NomeDoMotivoDeFadiga} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
              </div>
            </div>
            <div className="col-md-6">
              <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
            </div>
          </div>
        </form>
      </div>
      <hr/>
      <h4>{this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.tituloMotivosDeFadigaCadastrados}</h4>
      <table className="table">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              {this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.tabela.Nome}
            </th>
            <th className='col-md-1'>{this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.tabela.Acoes}</th>
          </tr>
        </thead>
        <tbody id="frotas">
          {Object.keys(self.state.data).map(function(k) {
            return (
              <tr>
                <td>
                  {self.state.data[k].id}
                </td>
                <td>
                  {self.state.data[k].name}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.data[k].id} onClick={self.delete}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueReasonsEdit;



// WEBPACK FOOTER //
// ./src/Components/FatigueReasons/FatigueReasonsEdit.js